<template>
    <div class="mt-number-wrap">
        <MtTitle title="产品案例" english="INTRODUCE" type="blue"></MtTitle>
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img1.png" alt="">
            <div class="text-content-title">运动功能饮料日加满</div>
            <div class="text-content-subtitle">EMPOWERING FOOD BRAND DAILY TOPPING UP</div>
            <div class="text-content">日加满根据都市各类人群推出日加满小绿瓶、甜睡、维生素水、欧李苏打水、槟力饮、蔓越莓等系列饮品,小程序上线<span>1月达到S级</span>，目前分数<span>SCI分数10分满分~</span></div>
        </div>
        <img data-src="../../static/img/content-img4.png" alt="">
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img2.png" alt="">
            <div class="text-content-title">魅力厨房是健康即食品牌</div>
            <div class="text-content-subtitle">EMPOWERING FOOD BRAND DAILY TOPPING UP</div>
            <div class="text-content">魅力厨房是一家将传统食品与现代化高科技完美结合,致力于满足消费者对<span>健康、便捷、美味、亲情</span>食品的需求,销售的食品新米粥、新米饭、红豆汤等。目前刚上线<br><span>国家体育总局授权训练局运动员战备保障产品</span>。</div>
        </div>
        <img data-src="../../static/img/content-img0.png" alt="">
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img3.png" alt="">
            <div class="text-content-title">女性卫生&纸类用品亲度</div>
            <div class="text-content-subtitle">SANITARY PRODUCTS BRAND</div>
            <div class="text-content">亲度是一个追求时尚、潮流、活力的卫生巾/纸类品牌，不断致力于让女性释放自由天性。<span>月活跃用户近20万用户！</span></div>
        </div>
        <img data-src="../../static/img/content-img5.png" alt="">
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img4.png" alt="">
            <div class="text-content-title">家庭清洁产品绿柠</div>
            <div class="text-content-subtitle">HOME CLEANING BRAND</div>
            <div class="text-content">绿柠品牌包括洗衣液、洗洁精、油污净、洁厕灵等家清产品，绿柠将致力于新多效洗涤等产品的研发，用 更新的科技与服务满足于新一代消费者的需求，<span>上线3个月支付宝端行业排名第57名！</span></div>
        </div>
        <img style="margin-bottom: 10vw" data-src="../../static/img/content-img8.png" alt="">
    </div>
</template>
<script>
import MtTitle from '../components/Mt-title'
export default {
    name: 'mt-number',
    components: {
        MtTitle
    },
    data(){
        return {

        }
    },
    created(){
        localStorage.setItem('path','./mt_number')
        localStorage.setItem('index',1)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
.mt-number-wrap > img{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 5vw;
}
.text-content-box{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 20vw;
    position: relative;
}
.number-bg{
    position: absolute;
    top: -8.5vw;
    left: 4.6vw;
    height: 32vw;
}
.text-content-title{
    font-size: 5.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 8.13vw;
}
.text-content-subtitle{
    font-size: 3.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 5.37vw;
}
.text-content{
    margin-top: 7vw;
    font-size: 3.38vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 6.35vw;
}
.text-content > span{
    font-size: 3.87vw;
    color: #4468E6;
}
</style>


// WEBPACK FOOTER //
// src/pages/mt_number.vue